import styled from 'styled-components';

export const TableContainer = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #f1f3f5;
  overflow: auto;
  thead {
    background: #f8f9fa;
    border-bottom: 1px solid #f1f3f5;
    position: sticky;
    left: 0;
    top: -1px;
    z-index: 9;
    tr {
      th {
        ${({ $hasIndex }) =>
          $hasIndex &&
          `
        &:first-child {
          padding: 11px 5px;
          text-align: center;
          
        }
        `}
        border-right: 1px solid #F1F3F5;

        &:last-child {
          text-align: right;
        }

        .th-wrapper {
          width: 100%;
          justify-content: space-between;
          display: flex;
          align-items: center;
        }

        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        padding: 12px 8px;
        color: #495057;
      }
    }
  }
  tbody {
    tr {
      border-bottom: 1px solid #f1f3f5;

      &:last-child {
        border-bottom: none;
      }

      /* &:hover {
        // background-color: #f3f3ff;

        td {
          &:first-child {
            color: #000;
          }
          color: #495bd1;
        }
      } */

      td {
        ${({ $hasIndex }) =>
          $hasIndex &&
          `
        &:first-child {
          background: #edf0f5;
          width: 30px;
          padding: 8px;
          text-align: center;
          border-right: 1px solid #F1F3F5;
        }

		
      `}

        border-right: 1px solid #F1F3F5;
        font-size: 14px;
        line-height: 21px;
        padding: 8px;
      }
    }
  }
`;
